import React from 'react';

const TwitterIcon = ({ color = '#ffffff', bgcolor = '#000000', ...props }) => (
	<svg width="32px" height="32px" viewBox="0 0 32 32" {...props}>
		<g>
			<g id="icon/social/twitter">
				<circle fill={bgcolor} cx="16" cy="16" r="16"></circle>
				<path
					d="M22.2016284,11.8706927 C22.2016284,11.8706927 23.4849859,11.7766828 24,11.4203603 C24,11.4203603 23.8765638,11.8305536 22.332281,13.1283841 C22.332281,13.1283841 22.8522325,20.1312465 14.9295226,21.8463122 C14.9295226,21.8463122 10.9115769,22.642052 8,20.6122113 C8,20.6122113 11.0479265,21.1150062 12.7627412,19.3566325 C12.7627412,19.3566325 10.5507632,19.3774062 9.85116434,17.2852443 C9.85116434,17.2852443 10.6863532,17.4524905 11.1827569,17.2433448 C11.1827569,17.2433448 8.6771904,16.7616757 8.72238707,14.2297443 C8.72238707,14.2297443 9.39957747,14.6902876 10.008783,14.6064884 C10.008783,14.6064884 7.75198804,12.827341 9.1511857,10.6098324 C9.1511857,10.6098324 12.1751846,13.9248281 15.9230897,13.7280058 C15.8577634,13.4906922 15.8224417,13.2421115 15.8224417,12.9850806 C15.8224417,11.3369133 17.2645572,10 19.043179,10 C19.9417951,10 20.7545755,10.3415343 21.3390937,10.8918624 C21.7675125,10.8985522 22.6486576,10.8277807 23.5286633,10.2436513 C23.5286633,10.2440034 23.5791773,10.8823557 22.2016284,11.8706927 L22.2016284,11.8706927 Z"
					id="Mask"
					fill={color}></path>
			</g>
		</g>
	</svg>
);

export default TwitterIcon;
